
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service/ppid/request-information",
      function () {
        return require("private-next-pages/service/ppid/request-information/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service/ppid/request-information"])
      });
    }
  